import type { RouteRecordRaw } from "vue-router";
import FlowLayout from "@/views/layouts/flowLayout.vue";


const registrationRouter: RouteRecordRaw[] = [
    {
        path: "/registration",
        name: "Registration",
        meta: { title: "我的报名" },
        component: FlowLayout,
        redirect: "/registration/myRegistration",
        children: [
            {
                path: "/registration/myRegistration",
                name: "MyRegistration",
                meta: { title: "报名列表" },
                component: () => import("@/views/pages/registration/registrationList/index.vue")
            },
            {
                path: "/registration/myRegistrationDetail",
                name: "MyRegistrationDetail",
                meta: { title: "报名详情" },
                component: () => import("@/views/pages/registration/registrationDetail/index.vue")
            },
        ]
    }
];

export default registrationRouter;
